let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5xf60")).then(() => parcelRequire('928dD'));